import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchBanners = createAsyncThunk('banners/fetchBanners', async () => {
    const { data } = await axios.get('/api/banners');
    return data;
});

export const createBanner = createAsyncThunk('banners/createBanner', async (bannerData, { getState, rejectWithValue }) => {
    const { user: { userInfo } } = getState();
    const config = {
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${userInfo.token}`,
        },
    };
    try {
        const { data } = await axios.post('/api/banners', bannerData, config);
        return data;
    } catch (error) {
        return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message);
    }
});

export const deleteBanner = createAsyncThunk('banners/deleteBanner', async (id, { getState, rejectWithValue }) => {
    const { user: { userInfo } } = getState();
    const config = {
        headers: {
            Authorization: `Bearer ${userInfo.token}`,
        },
    };
    try {
        await axios.delete(`/api/banners/${id}`, config);
        return id;
    } catch (error) {
        return rejectWithValue(error.response && error.response.data.message ? error.response.data.message : error.message);
    }
});

const bannerSlice = createSlice({
    name: 'banners',
    initialState: {
        banners: [],
        status: 'idle',
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchBanners.pending, (state) => { state.status = 'loading'; })
            .addCase(fetchBanners.fulfilled, (state, action) => { state.status = 'succeeded'; state.banners = action.payload; })
            .addCase(fetchBanners.rejected, (state, action) => { state.status = 'failed'; state.error = action.error.message; })
            .addCase(createBanner.fulfilled, (state, action) => { state.banners.push(action.payload); })
            .addCase(deleteBanner.fulfilled, (state, action) => { state.banners = state.banners.filter((banner) => banner._id !== action.payload); });
    },
});

export default bannerSlice.reducer;
